import React from 'react';
import { BaseFilterCheckboxSelect } from '../base/BaseFilterCheckboxSelect';
import { ISelectOption } from '../../../domain/saved-filters/interface';

interface IEnrollmentIdFilterSelectProps {
    value: string[];
    onChange: (value: string[]) => void;
    onSearch?: (value: string) => void;
    label?: string;
    height?: number;
    searchable?: boolean;
    disabled?: boolean;
    resizable?: boolean;
    options: ISelectOption<string>[];
    isLoading?: boolean;
}

export const EnrollmentIdFilterSelect: React.FC<IEnrollmentIdFilterSelectProps> = ({
    options,
    value,
    onChange,
    label,
    height = 300,
    searchable = true,
    disabled = false,
    resizable = true,
    isLoading = false,
}) => {
    return (
        <BaseFilterCheckboxSelect
            multiple
            resizable={resizable}
            loading={isLoading}
            searchable={searchable}
            showSelectAllOption={false}
            selectedCountInLabel
            disabled={disabled}
            options={options}
            value={value}
            onChange={onChange}
            label={label}
            height={height}
        />
    );
};
